import {
    FileExcelTwoTone,
    FileImageTwoTone,
    FilePdfTwoTone,
    FilePptTwoTone,
    FileTwoTone,
    FileWordTwoTone,
} from '@ant-design/icons';
import { ReactComponent as ArrowClockWise } from 'assets/icons/arrow-clock-wise.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download-icon.svg';
import { ReactComponent as PersonCircleGrayIcon } from 'assets/icons/person-circle-gray.svg';
import { UserToken } from 'domain/entities/UserEntity';
import React from 'react';
import { CHAT_STATUS, MessageEntity } from '..';
import { chatHelper } from '../utils/ChatHelpers';

interface Props {
    messageList: MessageEntity[];
    userLocal?: UserToken;
    resendMessage: (id: string, message: string) => void;
    handleScroll: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void;
}

const ChatMessage = ({ messageList, userLocal, resendMessage, handleScroll }: Props) => {
    const isCurrentUser = (userId: string) => {
        return userId === userLocal?.user.id;
    };

    const downloadFile = (file_url: string) => {
        window.open(file_url.replaceAll('\\', ''));
    };

    const trimMessage = (message: string, maxCharacter: number) => {
        return message.length > maxCharacter ? message.slice(0, maxCharacter) + '...' : message;
    };

    const renderFileIcon = (fileName: string) => {
        const fileExt = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
        const style = { fontSize: 30 };
        switch (fileExt) {
            case 'xlsx':
            case 'xls':
                return <FileExcelTwoTone style={style} />;

            case 'doc':
            case 'docx':
                return <FileWordTwoTone style={style} />;

            case 'pdf':
                return <FilePdfTwoTone style={style} />;

            case 'ppt':
            case 'pptm':
            case 'pptx':
                return <FilePptTwoTone style={style} />;

            default:
                return <FileTwoTone style={{ fontSize: 30 }} />;
        }
    };

    const renderMessage = (msg: any) => {
        switch (msg.messageType) {
            case 1:
                return msg.fileUrl ? (
                    [msg.fileUrl]?.map((file: any, idx: number) => (
                        <div
                            className={`file_download ${!isCurrentUser(msg.memberId) ? '' : 'you'}`}
                            key={msg.chatMessageId + '_' + idx}
                        >
                            <FileImageTwoTone style={{ fontSize: 30 }} />
                            <span>{trimMessage(msg.chatMessage || '', 40)}</span>
                            <div
                                className={`download_button ${!isCurrentUser(msg.memberId) ? '' : 'you'}`}
                                onClick={() => downloadFile(msg.fileUrl)}
                            >
                                <DownloadIcon
                                    width={24}
                                    height={24}
                                    fill={!isCurrentUser(msg.memberId) ? 'var(--primary)' : '#fff'}
                                />
                                <span>ダウンロード</span>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>{msg.chatMessage}</p>
                );

            case 2:
                return msg.fileUrl ? (
                    [msg.fileUrl]?.map((file: any, idx: number) => (
                        <div
                            className={`file_download ${!isCurrentUser(msg.memberId) ? '' : 'you'}`}
                            key={msg.chatMessageId + '_' + idx}
                        >
                            {renderFileIcon(msg.chatMessage)}
                            <span>{trimMessage(msg.chatMessage || '', 40)}</span>
                            <div
                                className={`download_button ${!isCurrentUser(msg.memberId) ? '' : 'you'}`}
                                onClick={() => downloadFile(msg.fileUrl)}
                            >
                                <DownloadIcon
                                    width={24}
                                    height={24}
                                    fill={!isCurrentUser(msg.memberId) ? 'var(--primary)' : '#fff'}
                                />
                                <span>ダウンロード</span>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>{msg.chatMessage}</p>
                );

            default:
                return <p style={{ whiteSpace: 'break-spaces' }}>{msg.chatMessage}</p>;
        }
    };

    const ChatStatus = ({ status }: { status?: string }) => {
        if (!status) return <></>;
        const lowerCaseStatus = status.toLowerCase();
        switch (lowerCaseStatus) {
            case CHAT_STATUS.SEND.toLowerCase():
                return <span>未読</span>;

            case CHAT_STATUS.SENDING.toLowerCase():
                return <span>送信中</span>;

            case CHAT_STATUS.READ.toLowerCase():
                return <span>既読</span>;

            case CHAT_STATUS.NOT_SEND.toLowerCase():
                return <span>未送信</span>;
            default:
                return <></>;
        }
    };

    return (
        <div className="message-display-section" onScroll={handleScroll}>
            <div style={{ marginTop: 51 }}></div>
            {messageList.map((msg) => (
                <div
                    className={`message-row ${!isCurrentUser(msg.memberId) ? '' : 'you'}`}
                    id={`message-id_${msg.chatMessageId}`}
                    key={`message-id_${msg.chatMessageId}`}
                >
                    {isCurrentUser(msg.memberId) && msg.messageStatus === CHAT_STATUS.NOT_SEND && (
                        <div
                            className="reload-btn"
                            onClick={() => resendMessage(msg.id ?? '', msg.chatMessage)}
                        >
                            <ArrowClockWise fill={'#fff'} />
                        </div>
                    )}
                    <div className="sender">
                        <PersonCircleGrayIcon width={46} height={46} />
                        <span>{isCurrentUser(msg.memberId) ? '' : '運営'}</span>
                    </div>
                    <div className="message-box">
                        <div className="triangle"></div>
                        <div className="message">{renderMessage(msg)}</div>
                    </div>
                    <div className="message-time">
                        <span>{chatHelper.formatSendDateTime(msg.sendAt)}</span>
                        {isCurrentUser(msg.memberId) && <ChatStatus status={msg.messageStatus} />}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ChatMessage;
